// removed by extract-text-webpack-plugin
module.exports = {"annualSection":"annualSection__2He27","annualFigure":"annualFigure__Byc3J","graphSection":"graphSection__-x9gB","graphContent":"graphContent__S6EAM","value":"value__3uNcX","description":"description__oi2cM","yearSlider":"yearSlider__1HtPN","yearText":"yearText__2Fdxs","notSelectedHeading":"notSelectedHeading__2GMYK","annualHeading":"annualHeading__2uJLv","previous":"previous__39nbE","next":"next__d5jll","inActivePrevious":"inActivePrevious__2IRTL","inActiveNext":"inActiveNext__2RFMJ"};


//////////////////
// WEBPACK FOOTER
// ./components/YearSummary/component/style.scss
// module id = nlfF
// module chunks = 22